<template>
  <div id="contact">
    <div id="sm-menu">
      <img v-on:click="closeMenu()" src="../assets/close.png" id="close" alt="オンライン専門ZOOMコンパニオン「ズムトーーーク☆」">
      <ul>
        <a href="/"><li class="hover">トップページ</li></a>
        <a href="/menu"><li class="hover">料金システム</li></a>
        <a href="/companion"><li class="hover">コンパニオン</li></a>
        <a href="/service"><li class="hover">サービス紹介</li></a>
        <a href="/contact"><li class="hover">お問い合わせ</li></a>
      </ul>
    </div>
    <SubHeader/>
    <div class="top">
     <p class="subTitle-row">お問い合わせ</p>
    </div>
    <div class="card-contents">
      <p style="text-align:left;">お名前：<br>
      <input v-model="name" type="text" name="name"></p>
      <p style="text-align:left;">メールアドレス：<br>
      <input v-model="mail" type="text" name="mail"></p>
      <p style="text-align:left;">電話番号：<br>
      <input v-model="tel" type="text" name="tel"></p>
      <p style="text-align:left;">お問合せ内容：<br>
      <textarea v-model="content" name="content" cols="30" rows="5"></textarea></p>
      <button v-on:click="send()" id="send">送信</button>
    </div>
  </div>
</template>
<style scoped>
.top{
  padding-top: 0px;
}
#contact .subTitle-row{
  background-image: url(../assets/bg-title.jpg);
background-size:cover;
  height: 50px;
  line-height: 50px;
 color:white;
 box-shadow: 4px 4px #005FFF;
  width: 70%;
  margin:36px auto;
  font-size:24px;
  border-radius: 5px 5px 5px 5px;
  font-weight: bold;
  border: 5px solid  white;
}
.card-contents{
  background-color: white;
   box-shadow: 4px 4px #006600;
  width: 70%;
  margin: 36px auto;
  text-align: center;
}
#contact .card-contents p{
  margin-right: 16px;
  margin-left: 16px;
   color: #555555;
  font-size: 20px;
}
#contact input{
  width: 90%;
  margin-left: 2%;
  border: 2px solid #555555;
  height: 24px;
  font-size: 20px;
}
#contact textarea {
  width: 90%;
  margin-left: 2%;
  border: 2px solid #555555;
  height: 100px;
  font-size: 20px;
}
#contact span{
  color:#ffff66;
}
#send{
  border-radius: 20px 20px 20px 20px;
  background-color:rgba(255,215,0,0.9);
  color: white;
  border: 0px inset black;
  width: 200px;
  font-size: 20px;
  margin-top: 8px;
  margin-bottom: 8px;
}
#sm-menu{
  background-color:rgba(0,0,0,0.9);
  display: none;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background-color: black;
  position: fixed;
}
#close{
display: block;
position: absolute;
width: 64px;
height:64px;
top:16px;
right:16px;
}
@media ( max-width : 680px ){
  .card-contents{
  width: 90%;
}
 .subTitle-row{
  margin:0px auto;
}
.top{
  padding-top: 50px;
}
 a{
    color: #555555!important;
   font-weight: bold;
  text-decoration: none;
  font-size:24px;
}
   #sm-menu li{
    display: block;
   background-image: url(../assets/bg-body.jpg);
    color: #555555!important;
     margin-left: 16px;
     margin-right: 16px;
    margin-top: 16px;
     margin-bottom: 16px;
     font-size:24px;
     line-height: 70px;
  border-radius: 10px 10px 10px 10px;
  height: 70px;
  }
  #sm-menu  li a{
   color: white;
  text-decoration: none;
  font-size:24px;
  line-height:70px;
}
  #sm-menu ul{
    margin-top: 100px;
     color: #555555!important;
     padding:inherit;

  }
  .subTitle-row{
    width: 90%;
  }
  #contact .item {
  border-radius: 10px;
   box-shadow: 4px 4px #555555;
  background-color:rgba(208,255,67,0.7);
  margin: 0 auto;
  width: 30%;
  text-align: center;
}
#contact .flexbox {
    display: flex;
    flex-wrap: wrap;
    width: 90%;
    margin-left: 5%;
    justify-content: center;
    }
    .main {
  margin-bottom: 10px;
  width: 100%;
}
.side {
  background-color:rgba(255,54,127,0.7);
  border-radius: 10px 10px 10px 10px;
  width: 100%;
  margin-bottom: 36px;
}
#contact .subTitle-row{
  width: 90%;
}
}
</style>
<script>
import SubHeader from './common/SubHeader'
import Footer from './common/Footer'
import firebase from 'firebase'
import $ from 'jquery'
export default {
  name: 'app',
  components: {
    SubHeader, Footer
  },
  data () {
    return {
      db: null,
      name: '',
      mail: '',
      tel: '',
      content: ''
    }
  },
  created: function () {
    this.db = firebase.firestore()
  },
  methods: {
    submit: function () {
      if (!this.name) {
        alert('名前が入力されていません。')
        return
      }
      if (!this.mail) {
        alert('メールが入力されていません。')
        return
      }
      if (!this.tel) {
        alert('電話番号が入力されていません。')
        return
      }
      if (!this.content) {
        alert('お問い合わせ内容が入力されていません。')
        return
      }
      let collection = this.db.collection('contact')
      collection.add({
        name: this.name,
        mail: this.mail,
        tel: this.tel,
        date: new Date(),
        content: this.content
      }).then(function (docRef) {
        alert('お問い合わせの送信が完了しました。')
      }).catch(function (error) {
        console.log(error)
        alert('お問い合わせの送信が失敗しました。再度、実行してください。')
      })
    },
    closeMenu: function () {
      document.getElementById('sm-menu').style.display = 'none'
      document.getElementById('sm-menu-icon').style.display = 'block'
    },
    send: function () {
      if (!this.name) {
        alert('名前が入力されていません。')
        return
      }
      if (!this.mail) {
        alert('メールが入力されていません。')
        return
      }
      if (!this.tel) {
        alert('電話番号が入力されていません。')
        return
      }
      if (!this.content) {
        alert('お問い合わせ内容が入力されていません。')
        return
      }
      var data = { 'name': this.name, 'mail': this.mail, 'tel': this.tel, 'content': this.content }
      $.ajax({
        url: 'https://asia-northeast1-keipromotion-43a49.cloudfunctions.net/contactZoom',
        type: 'GET',
        data: data
      })
        .done(function (data) {
          alert('お問い合わせを送信しました。')
        })
        .fail(function () {
          alert('お問い合わせを送信しました。')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue